<template>
  <main id="main">
    <section class="section section__content" v-if="$page">
      <TitleBlock :content="$page.header" centered />
      <Chat :messages="$page.chat" render-cache-key="welcome" />
    </section>
  </main>
</template>

<script>
import { Chat, TitleBlock } from '@/components/blocks'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Welcome',
  mixins: [PageMetaMixin],
  beetPage: 'hunt_welcome',
  components: { Chat, TitleBlock },
}
</script>
